module.exports = __webpack_public_path__ + "img/verlassen.1652ed5d.svg";